module.exports = __webpack_public_path__ + "img/aboutbg@2x.132e3adf.png";